export default (() => {

    function toDate (dateString) {
        if (dateString === undefined) {            
            return wealthify.error.throwError('type.date.toDate', 'dateString must be defined');
        }

        if (typeof dateString !== 'string') {
            return wealthify.error.throwError('type.date.toDate', 'dateString must be a string');
        }

        const dateParts = dateString.split('-');

        if (dateParts.length !== 3) {
            return wealthify.error.throwError('type.date.toDate', 'dateString must be separated by - delimiter');
        }

        const date = new Date(dateString);

        if (date.toString() === 'Invalid Date') {
            return wealthify.error.throwError('type.date.toDate', 'dateString must be in format YYYY-MM-DD');
        }

        const dayIsCorrect = date.getDate() == dateParts[2];
        const monthIsCorrect = date.getMonth() == (dateParts[1] - 1);
        const yearIsCorrect = date.getFullYear() == dateParts[0];

        if (!dayIsCorrect || !monthIsCorrect || !yearIsCorrect) {
            return wealthify.error.throwError('type.date.toDate', 'dateString must be in format YYYY-MM-DD');
        }

        return date;
    }

    function toOrdinalDay (day) {
        if (typeof day !== 'number') {
            return wealthify.error.throwError('type.date.toOrdinalDay', 'day must be of type number');
        }

        // To define any ordinal numbers used for days that don't end in "th"
        const extendedLabelMap = {
            1: '1st',
            2: '2nd',
            3: '3rd',
            21: '21st',
            22: '22nd',
            23: '23rd',
            31: '31st'
        };

        return extendedLabelMap[day] ?? `${day}th`;
    }

    return {
        toDate,
        toOrdinalDay
    };

})();